import React, { FC, memo, useEffect } from 'react'

import styles from './styles.module.scss'

interface IProps {
  params: string
  apiKey: string
  getValues: (key: string) => string
}

const WidgetDemo: FC<IProps> = ({ apiKey, params, getValues }) => {
  useEffect(() => {
    const sendParentURL = (event: any) => {
      if (
        event &&
        event.data === 'RequestParentURL' &&
        event.source &&
        event.source.postMessage &&
        event.origin
      ) {
        event.source.postMessage(window.location.href, event.origin)
      }
    }

    window.addEventListener('message', sendParentURL)

    return () => {
      window.removeEventListener('message', sendParentURL)
    }
  }, [])

  return (
    <div className={styles.demoWidget}>
      <iframe
        id={`authencityWidget_${apiKey}`}
        width={getValues('width')}
        height={getValues('height')}
        src={`${window.origin}/widget/${apiKey}?${params}&isDemo=true`}
        title="Authencity Widget"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  )
}

WidgetDemo.displayName = 'WidgetDemo'

export default memo(WidgetDemo)
